import React from 'react';

import cn from 'classnames';

import { func, string, arrayOf, shape, oneOf, bool } from 'prop-types';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import { ensureArray } from 'utils/arrays';

import s from './SelectWithNodeLabel.css';

/**
 * SelectWithNodeLabel is rendered by Select common component.
 * SelectWithNodeLabel provides the functionality to display selected value as JSX
 *
 * @param onChange - function to run when value changes
 * @param value - selected value
 * @param options - options to select from
 * @param getOptionNodeLabel - a function which returns JSX element for rendering the selected value
 * @param variant - for different types of outline
 * @param sx - to provide additional styling to MUI Select component
 * @param testId - ID for data-testid
 * @param disabled - if true, field is disabled
 */
const SelectWithNodeLabel = ({
  onChange,
  value,
  options,
  getOptionNodeLabel,
  variant,
  sx,
  testId,
  className,
  disabled,
}) => (
  <Select
    // eslint-disable-next-line css-modules/no-undef-class
    className={cn(s.container, className)}
    renderValue={getOptionNodeLabel}
    value={value}
    onChange={onChange}
    variant={variant}
    sx={sx}
    data-testid={testId}
    disabled={disabled}
  >
    {ensureArray(options).map(option => (
      <MenuItem key={option} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </Select>
);

SelectWithNodeLabel.propTypes = {
  onChange: func.isRequired,
  getOptionNodeLabel: func.isRequired,
  value: string.isRequired,
  options: arrayOf(shape({})).isRequired,
  variant: oneOf(['standard', 'outlined', 'filled']),
  sx: shape({}),
  testId: string,
  className: string,
  disabled: bool.isRequired,
};

SelectWithNodeLabel.defaultProps = {
  variant: 'outlined',
  sx: {},
  testId: '',
  className: '',
};

export default SelectWithNodeLabel;
